// Library methods
import { ReactNode } from "react";

// Components
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import { InfoIcon } from "src/assets/icons";

// Styles
import { getSurfaceTokens } from "src/styles/mui/muiStylesHelper";

type InfoNoteType = {
  testId?: string;
  tone?: "info" | "warning";
  children: ReactNode;
};

const InfoNote = ({ testId, tone = "info", children }: InfoNoteType) => {
  const theme = useTheme();
  const { onSurface } = getSurfaceTokens(theme);
  const isDark = theme.palette.mode === "dark";

  return (
    <Box
      data-testid={testId}
      role={tone === "warning" ? "alert" : undefined}
      sx={{
        display: "flex",
        gap: "10px",
        alignItems: "flex-start",
        padding: "10px 12px",
        borderRadius: "8px",
        border: tone === "warning" ? "1px solid #FFC48A" : "none",
        backgroundColor: isDark ? "#4F5266" : "rgba(0, 0, 0, 0.05)",
      }}
    >
      <InfoIcon
        aria-hidden="true"
        width="16"
        height="16"
        style={{
          flexShrink: 0,
          marginTop: "1px",
          color: tone === "warning" ? "#FFC48A" : onSurface,
        }}
      />
      <Typography fontSize="12px" color={onSurface} lineHeight={1.45}>
        {children}
      </Typography>
    </Box>
  );
};

export default InfoNote;
